const IOS_REGEX = /ios|iPad|iPhone|iPod/i;
const BROWSER_REGEX = /Chrome|CriOS|FxiOS|EdgiOS|Opr/i;
const SAFARI_REGEX = /Safari/i;

export function checkSafariUserAgent(): boolean {
  const userAgent = navigator.userAgent;

  if (userAgent == null) {
    return false;
  }

  const isAppleDevice = IOS_REGEX.test(userAgent);

  const isSafari = SAFARI_REGEX.test(userAgent) && !BROWSER_REGEX.test(userAgent);

  return isAppleDevice && isSafari;
}
